/**
 * Le lien vers la liste des produits en texte brut, lisible par lecteur d'écran.
 *
 * Demande d'une cliente qui perd la vue (09/2026). Ce composant existe pour une
 * seule raison : ce lien doit être TOUJOURS là, et toujours en haut.
 *
 * Deux placements ont été essayés et écartés, chacun pour un motif qui vaut
 * d'être retenu :
 *
 *  - le PIED DE PAGE seul : sur le catalogue il vit au bas de la zone qui
 *    défile, derrière 1 160 produits et un bouton « Charger plus ». Inatteignable
 *    au doigt sur téléphone, et invisible pour un lecteur d'écran — qui ne
 *    parcourt pas un catalogue entier pour trouver un lien ;
 *  - le BANDEAU d'état de la boutique : il se retire complètement dès que la
 *    boutique prend commande (`if (ordering.open) return null`), c'est-à-dire
 *    précisément du mercredi au samedi 18 h — toute la période où elle
 *    commanderait. Un lien d'accessibilité qui disparaît aux heures d'ouverture
 *    est un lien qui n'existe pas.
 *
 * Il n'est donc accroché à aucun état : ni à l'ouverture de la boutique, ni à
 * une session, ni à un compte — la personne qui en a besoin n'en a pas
 * forcément un.
 */
import { useTenant } from '../../contexts/TenantContext';

export default function LienListeAccessible({ className = '' }: { className?: string }) {
  // Le magasin voyage dans l'URL : un lien de téléchargement n'emporte pas
  // l'en-tête `x-tenant-id` que l'application ajoute à ses appels.
  const { tenant } = useTenant();
  const base = import.meta.env.VITE_API_URL || '/api';

  return (
    <a
      href={`${base}/shop-config/liste-produits.txt${tenant?.id ? `?t=${tenant.id}` : ''}`}
      className={`underline underline-offset-2 ${className}`}
    >
      Liste des produits à télécharger (texte, lecteur d'écran)
    </a>
  );
}
